import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import firebase from "./firebaseConfig.js";

import VueAnalytics from 'vue-analytics'
Vue.use(VueAnalytics, { id: 'UA-138212304-2', router })

import { detect } from 'detect-browser'
const browser = detect();

if (browser) {
  store.commit("setBrowser", browser.name);
}

store.dispatch("getVersion");

Vue.config.productionTip = false

firebase.auth().useDeviceLanguage();

firebase.auth().onAuthStateChanged(user => {
  store.commit("setUser", user);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
